module.exports = __webpack_public_path__ + "static/media/team1.caa4ad1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/about-company/img/team1.jpg
// module id = 1716
// module chunks = 146